function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var genChoiceModalStyles = function genChoiceModalStyles(prefixCls, token) {
  return [_defineProperty(_defineProperty({}, ".noPaddingModal.ant-modal .ant-modal-content", _defineProperty({
    padding: '0'
  }, ".form-item", {
    paddingBottom: '0px'
  })), ".".concat(prefixCls), _defineProperty(_defineProperty({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    backgroundColor: '#fff',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0px 9px 28px 8px #0000000D, 0px 3px 6px -4px #0000001F, 0px 6px 16px 0px #00000014'
  }, ".left", _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  }, ".header", _defineProperty(_defineProperty({
    position: 'sticky',
    top: 0,
    backgroundColor: '#fff',
    zIndex: 1,
    padding: '0px 24px'
  }, ".title", {
    padding: '16px 0px 0px 0px',
    fontSize: '16px',
    fontWeight: 500
  }), ".searchInputWrap", _defineProperty({
    padding: '8px 0px'
  }, ".searchInput", {
    borderRadius: '6px'
  })))), ".right", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column'
  }, ".selectedCount", {
    color: '#0D1121',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    padding: '16px 24px 8px 24px'
  }), ".listWrap", _defineProperty({
    padding: '0px',
    height: '400px'
  }, ".emptyWrap", {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  })), ".listItem", _defineProperty(_defineProperty(_defineProperty({
    borderBottom: '1px solid #EEEEF3'
  }, ".itemContent", _defineProperty(_defineProperty({
    marginLeft: '24px'
  }, ".title", {
    fontSize: '14px',
    color: '#0D1121'
  }), ".subTitle", {
    fontSize: '12px',
    color: '#6E707A'
  })), ".itemClose", {
    marginRight: '24px',
    cursor: 'pointer',
    padding: '0 4px'
  }), ".itemClose:hover", {
    color: '#FF4D4F',
    backgroundColor: '#FFF1F0',
    padding: '0px 4px'
  })), ".listItem:hover", {
    backgroundColor: '#E7E7E7'
  }), ".footer", {
    display: 'flex',
    gap: '8px',
    padding: '16px 24px',
    borderTop: '1px solid #EEEEF3'
  })))];
};